import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Master switch for the feed's filter chips. Off by default so every existing
// feed renders byte-identically until an author opts in.
export default class FeedFiltersEnabled extends BaseOption {
  static userInterfaceComponent = {
    label: "Filters",
    component: inspectorTools.RADIO_BAR,
    optionDataType: BaseOption.DataType.Boolean,
    descriptionMessage:
      "Show a row of chips above this feed that narrow it to one hashtag.",
    props: {
      options: [
        { label: "On", value: true, tooltip: "" },
        { label: "Off", value: false, tooltip: "" },
      ],
    },
  };

  static defaultValue = false;
}
